export default __webpack_public_path__ + "static/media/Flag.6ad6859e.svg";